import React, { Fragment, useState } from "react";
import { Button, Divider, Space, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faCalendarDay,
  faFolderOpen,
  faPaste,
  faSheetPlastic,
  faSliders,
} from "@fortawesome/free-solid-svg-icons";
import { appTheme } from "../../config/theme";
import { ModeleSommaire } from "../client/outils/files/ModèleSommaire";
import { ListeFileSommaire } from "../client/outils/files/ListeFileSommaire";
import { NormesISA } from "../client/outils/files/NormesISA";
import { RateauxSommaire } from "../client/outils/RateauxSommaire";
import { NextControleSommaire } from "../client/outils/NextControleSommaire";
import { ModalPlanComptable } from "../client/outils/ModalPlanComptable";

// Styles communs pour les boutons
const ButtonStyles = {
  backgroundColor: "white",
  border: "none",
  marginRight: "15px",
  color: appTheme.colors.primary_blue,
};

const ModalToolbarHeader = ({ codeSommaire, client, mission }) => {
  // État pour gérer quel modal est ouvert
  const [activeModal, setActiveModal] = useState(null);

  // Fonction pour ouvrir/fermer les modals
  const toggleModal = (modalId) => {
    setActiveModal(activeModal === modalId ? null : modalId);
  };

  // Configuration des boutons avec leurs propriétés
  const buttonConfig = [
    {
      id: 1,
      icon: faPaste,
      tooltip: `Modèles du cycle ${codeSommaire || ""}`,
      component: ModeleSommaire,
      isLeftSection: true,
    },
    {
      id: 2,
      icon: faFolderOpen,
      tooltip: `Documents du cycle ${codeSommaire || ""}`,
      component: ListeFileSommaire,
      isLeftSection: true,
    },
    {
      id: 3,
      icon: faBook,
      tooltip: `Normes ISA du cycle ${codeSommaire || ""}`,
      component: NormesISA,
      isLeftSection: true,
    },
    {
      id: 6,
      icon: faSheetPlastic,
      tooltip: "Plan comptable",
      component: ModalPlanComptable,
      isLeftSection: true,
    },
    {
      id: 4,
      icon: faSliders,
      tooltip: `Râteaux du cycle ${codeSommaire || ""}`,
      component: RateauxSommaire,
      isLeftSection: false,
    },
    {
      id: 5,
      icon: faCalendarDay,
      tooltip: `Prochain contrôle du cycle ${codeSommaire || ""}`,
      component: NextControleSommaire,
      isLeftSection: false,
    },
  ];

  // Fonction pour rendre un bouton
  const renderButton = (config) => {
    const buttonStyle = config.isLeftSection
      ? ButtonStyles
      : { ...ButtonStyles, color: appTheme.colors.primary };

    return (
      <Tooltip
        key={config.id}
        color={appTheme.colors.primary_blue}
        title={config.tooltip}
      >
        <Button
          className={
            config.isLeftSection
              ? "button-toolbar-left"
              : "button-toolbar-right"
          }
          icon={<FontAwesomeIcon size="2x" icon={config.icon} />}
          style={buttonStyle}
          onClick={() => toggleModal(config.id)}
        />
      </Tooltip>
    );
  };

  // Fonction pour rendre le modal actif
  const renderActiveModal = () => {
    const activeConfig = buttonConfig.find(
      (config) => config.id === activeModal
    );
    if (!activeConfig) return null;

    const ModalComponent = activeConfig.component;
    return (
      <ModalComponent
        handleVisibility={toggleModal}
        client={client}
        mission={mission}
        visible={true}
        codeSommaire={codeSommaire}
      />
    );
  };

  // Séparer les boutons en deux sections
  const leftButtons = buttonConfig.filter((config) => config.isLeftSection);
  const rightButtons = buttonConfig.filter((config) => !config.isLeftSection);

  return (
    <Fragment>
      {/* Barre d'outils avec boutons */}
      <div
        style={{
          borderRadius: "15px",
          backgroundColor: "white",
          padding: "20px",
        }}
      >
        <Space>
          {/* Section gauche - boutons principaux */}
          {leftButtons.map(renderButton)}

          {/* Séparateur vertical */}
          <Divider
            type="vertical"
            style={{ fontSize: "30px", marginRight: "5px" }}
          />

          {/* Section droite - boutons secondaires */}
          {rightButtons.map(renderButton)}
        </Space>
      </div>

      {/* Rendu conditionnel du modal actif */}
      {renderActiveModal()}
    </Fragment>
  );
};

export default ModalToolbarHeader;
